import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { API, axios } from "@/utils/constants";
import { hydrateAfsolForm } from "@/utils/afsol";
import { AfsolPrintDocument } from "@/components/afsol/AfsolPrintDocument";

export const AfsolPrintPreviewPage = () => {
  const { afsalId, mode } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(null);
  const hasTriggeredPrint = useRef(false);

  useEffect(() => {
    const fetchAfsal = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${API}/afsals/${afsalId}`);
        setForm(hydrateAfsolForm(response.data.form_data, response.data.form_data?.general?.createdBy || ""));
      } catch (error) {
        navigate("/afsol");
      } finally {
        setLoading(false);
      }
    };

    fetchAfsal();
  }, [afsalId, navigate]);

  useEffect(() => {
    if (loading || !form || hasTriggeredPrint.current) {
      return;
    }

    hasTriggeredPrint.current = true;
    const timeoutId = window.setTimeout(() => {
      window.print();
    }, 250);

    return () => window.clearTimeout(timeoutId);
  }, [form, loading]);

  if (loading || !form) {
    return <div className="min-h-screen bg-white" data-testid="afsol-print-preview-loading" />;
  }

  return (
    <div className="min-h-screen bg-white" data-testid="afsol-print-preview-page">
      <div id="print-area">
        <AfsolPrintDocument form={form} mode={mode === "handwritten" ? "handwritten" : "electronic"} />
      </div>
    </div>
  );
};

export default AfsolPrintPreviewPage;